import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GetOutlookMobileComponent } from './GetOutlookMobileComponent';
import { OutlookMobileContainer } from '../utils/OutlookMobileContainer';
import { ActionButton, IButtonStyles } from '@fluentui/react/lib/Button';
import { FontWeights } from '@uifabric/styling';
import { updateUserOutlookClient } from '../services/updateUserOutlookClient';
import { owaDate } from 'owa-datetime';
import { getUserOutlookClientByType } from '../selectors/getUserOutlookClientByType';
import { OutlookClientsToUpdate } from '../utils/phoneAppCardUtils';
import { getPalette } from 'owa-theme';
import { dismissButtonText } from './EmptyStateMobilePromo.locstring.json';
import { getClientVersion } from 'owa-config';
import loc from 'owa-localize';
import { logUsage } from 'owa-analytics';
import { getMobileContainerName } from '../utils/getMobileContainerName';
import isBusiness from 'owa-session-store/lib/utils/isBusiness';

const styles = require('./PhoneAppCard.scss');
export const EmptyStateMobilePromo = observer(function EmptyStateMobilePromo(props: {
    containerName: OutlookMobileContainer;
    onComponentUnmount?: () => void;
}) {
    const onDimissClick = React.useCallback(() => {
        logUsage(
            'EmptyStateMobilePromoDismiss',
            { containerName: getMobileContainerName(props.containerName) },
            { isCore: true }
        );

        OutlookClientsToUpdate.forEach(clientType => {
            let userClient = getUserOutlookClientByType(clientType);
            if (userClient) {
                updateUserOutlookClient({
                    clientId: userClient.clientId,
                    clientType: userClient.clientType,
                    clientVersion: getClientVersion(),
                    mobilePromoDismissDate: owaDate(),
                });
            }
        });

        if (props.onComponentUnmount) {
            props.onComponentUnmount();
        }
    }, []);

    return (
        <div className={styles.getOutlookMobileContainer}>
            <div className={styles.getOutlookMobileComponent}>
                <GetOutlookMobileComponent
                    containerName={props.containerName}
                    onComponentUnmount={props.onComponentUnmount}
                />
                {isBusiness() && (
                    <div className={styles.dismissButton}>
                        <ActionButton styles={getButtonStyles()} onClick={onDimissClick}>
                            {loc(dismissButtonText)}
                        </ActionButton>
                    </div>
                )}
            </div>
        </div>
    );

    function getButtonStyles(): IButtonStyles {
        let defaultPalette = getPalette();

        return {
            root: {
                color: defaultPalette.themeDarkAlt,
            },
            rootHovered: {
                color: defaultPalette.themeDark,
            },
            rootPressed: {
                color: defaultPalette.themeDarker,
            },
            label: {
                fontWeight: FontWeights.semibold,
                fontSize: '12px',
            },
        };
    }
});
